const loginMessages = {
  nl: {
    login: {
      service: {
        label: "VLECAD® Insights",
        message: "Software die denkt als een vakman",
      },
      account: {
        customer: "Klant {number}",
      },
      actions: {
        login: "Inloggen",
        cancel: "Annuleren",
        signIn: "Aanmelden",
      },
      hero: {
        eyebrow: "Welkom bij VLECAD Insights",
        title: "Van cijfers naar helder inzicht.",
        intro: "Krijg een duidelijk beeld van uw gegevens en ontdek in één oogopslag waar nieuwe kansen liggen.",
        benefits: {
          reporting: "Overzichtelijke rapportering",
          tailored: "Inzichten op maat van uw organisatie",
          secure: "Eén beveiligde klantomgeving",
        },
      },
      form: {
        access: "Beveiligde toegang",
        title: "Welkom terug",
        intro: "Meld u aan om uw persoonlijke inzichten te bekijken.",
        username: "Gebruikersnaam",
        password: "Wachtwoord",
        registrationTrigger: "R",
        registrationText: "egistreren kan via",
        registrationSite: "www.my.vlecad.be",
        wordpressLogin: "Inloggen via WordPress",
      },
      returnCard: {
        title: "Klaar om verder te gaan?",
        intro: "Open het aanmeldvenster om uw persoonlijke omgeving te bekijken.",
      },
      errors: {
        insightsData: "Het ophalen van de Insights-gegevens is niet gelukt.",
        contractExpired: "De einddatum van uw contract is verstreken.",
        contractFetch: "Het ophalen van uw contract is niet gelukt.",
        authenticationFailed: "Aanmelden is niet gelukt. Controleer uw gebruikersnaam en wachtwoord.",
        unexpected: "Er is een onverwachte fout opgetreden tijdens het aanmelden.",
      },
    },
  },
  en: {
    login: {
      service: {
        label: "VLECAD® Insights",
        message: "Software that thinks like a craftsman",
      },
      account: {
        customer: "Customer {number}",
      },
      actions: {
        login: "Log in",
        cancel: "Cancel",
        signIn: "Sign in",
      },
      hero: {
        eyebrow: "Welcome to VLECAD Insights",
        title: "From figures to clear insights.",
        intro: "Get a clear view of your data and discover new opportunities at a glance.",
        benefits: {
          reporting: "Clear reporting",
          tailored: "Insights tailored to your organisation",
          secure: "One secure customer environment",
        },
      },
      form: {
        access: "Secure access",
        title: "Welcome back",
        intro: "Sign in to view your personal insights.",
        username: "Username",
        password: "Password",
        registrationTrigger: "R",
        registrationText: "egister at",
        registrationSite: "www.my.vlecad.be",
        wordpressLogin: "Sign in via WordPress",
      },
      returnCard: {
        title: "Ready to continue?",
        intro: "Open the sign-in window to view your personal environment.",
      },
      errors: {
        insightsData: "We could not retrieve the Insights data.",
        contractExpired: "Your contract has expired.",
        contractFetch: "We could not retrieve your contract.",
        authenticationFailed: "Sign-in failed. Check your username and password.",
        unexpected: "An unexpected error occurred while signing in.",
      },
    },
  },
  fr: {
    login: {
      service: {
        label: "VLECAD® Insights",
        message: "Un logiciel qui pense comme un professionnel",
      },
      account: {
        customer: "Client {number}",
      },
      actions: {
        login: "Se connecter",
        cancel: "Annuler",
        signIn: "Connexion",
      },
      hero: {
        eyebrow: "Bienvenue dans VLECAD Insights",
        title: "Des chiffres à une vision claire.",
        intro: "Obtenez une vue claire de vos données et découvrez de nouvelles opportunités en un coup d’œil.",
        benefits: {
          reporting: "Rapports clairs",
          tailored: "Des analyses adaptées à votre organisation",
          secure: "Un environnement client unique et sécurisé",
        },
      },
      form: {
        access: "Accès sécurisé",
        title: "Heureux de vous revoir",
        intro: "Connectez-vous pour consulter vos analyses personnelles.",
        username: "Nom d’utilisateur",
        password: "Mot de passe",
        registrationTrigger: "L",
        registrationText: "’inscription se fait sur",
        registrationSite: "www.my.vlecad.be",
        wordpressLogin: "Se connecter via WordPress",
      },
      returnCard: {
        title: "Prêt à continuer ?",
        intro: "Ouvrez la fenêtre de connexion pour consulter votre environnement personnel.",
      },
      errors: {
        insightsData: "Impossible de récupérer les données Insights.",
        contractExpired: "Votre contrat a expiré.",
        contractFetch: "Impossible de récupérer votre contrat.",
        authenticationFailed: "La connexion a échoué. Vérifiez votre nom d’utilisateur et votre mot de passe.",
        unexpected: "Une erreur inattendue s’est produite lors de la connexion.",
      },
    },
  },
  de: {
    login: {
      service: {
        label: "VLECAD® Insights",
        message: "Software, die wie ein Fachmann denkt",
      },
      account: {
        customer: "Kunde {number}",
      },
      actions: {
        login: "Einloggen",
        cancel: "Abbrechen",
        signIn: "Anmelden",
      },
      hero: {
        eyebrow: "Willkommen bei VLECAD Insights",
        title: "Von Zahlen zu klaren Erkenntnissen.",
        intro: "Verschaffen Sie sich einen klaren Überblick über Ihre Daten und erkennen Sie neue Chancen auf einen Blick.",
        benefits: {
          reporting: "Übersichtliche Berichte",
          tailored: "Auf Ihre Organisation zugeschnittene Erkenntnisse",
          secure: "Eine sichere Kundenumgebung",
        },
      },
      form: {
        access: "Sicherer Zugang",
        title: "Willkommen zurück",
        intro: "Melden Sie sich an, um Ihre persönlichen Erkenntnisse einzusehen.",
        username: "Benutzername",
        password: "Passwort",
        registrationTrigger: "R",
        registrationText: "egistrieren können Sie sich unter",
        registrationSite: "www.my.vlecad.be",
        wordpressLogin: "Über WordPress anmelden",
      },
      returnCard: {
        title: "Bereit, fortzufahren?",
        intro: "Öffnen Sie das Anmeldefenster, um Ihre persönliche Umgebung aufzurufen.",
      },
      errors: {
        insightsData: "Die Insights-Daten konnten nicht abgerufen werden.",
        contractExpired: "Ihr Vertrag ist abgelaufen.",
        contractFetch: "Ihr Vertrag konnte nicht abgerufen werden.",
        authenticationFailed: "Die Anmeldung ist fehlgeschlagen. Prüfen Sie Ihren Benutzernamen und Ihr Passwort.",
        unexpected: "Bei der Anmeldung ist ein unerwarteter Fehler aufgetreten.",
      },
    },
  },
};

export const nl = loginMessages.nl;
export const en = loginMessages.en;
export const fr = loginMessages.fr;
export const de = loginMessages.de;

export default loginMessages;
